// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"305c4dd2","774":"52450ada","787":"5514e4e3"}[chunkId] + ".chunk.js";
};